import LoginAdmin from '../componentes/Login/Admin';

function Admin() {
  return (
    <LoginAdmin />
  );
}

export default Admin;
